<template>
  <div class="navi">
    <div class="icon"></div>
    <el-breadcrumb separator="/" style="height: 60px; line-height: 60px">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.navi {
  width: 1200px;
  height: 60px;
  line-height: 60px;
  // margin: 20px auto;
  display: flex;
  justify-content: flex-start;
  align-content: flex-end;
  ::v-deep .el-breadcrumb {
    line-height: 25px;
    cursor: pointer;
  }
  ::v-deep .el-breadcrumb__inner {
    cursor: pointer;
  }
  .icon {
    width: 16px;
    height: 16px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("../../../../static/hourse.png");
    vertical-align: middle;
    margin-right: 5px;
    margin-top: 21px;
  }
}
</style>
>
